import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { GalleryLayout12 } from '@components/gallery/components/gallery-layout-12/model';
import { ImageComponent } from '@shared/components/image';
import { ParallaxDirective } from '@shared/directives';

@Component({
  selector: 'app-gallery-layout-12',
  imports: [ParallaxDirective, ImageComponent],
  templateUrl: './gallery-layout-12.component.html',
  styleUrl: './gallery-layout-12.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GalleryLayout12Component {
  readonly data = input.required<GalleryLayout12>();
}
